import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppToolbarComponent } from '@raxapp/ui/app-toolbar/app-toolbar.component';
import { BusyIndicatorComponent } from '@raxapp/ui/busy/busy-indicator.component';
import { UsersUserSideMenuComponent } from '@raxapp/users/user-side-menu/user-side-menu.component';

@Component({
    selector: 'rax-main-container',
    templateUrl: './main-container.component.html',
    styleUrls: ['./main-container.component.css'],
    imports: [AppToolbarComponent, BusyIndicatorComponent, RouterOutlet, UsersUserSideMenuComponent],
})
export class MainContainerComponent {}
